// extracted by mini-css-extract-plugin
export var aboutSection = "AboutSectionWithCard-module--aboutSection--3affW";
export var aboutSectionMain = "AboutSectionWithCard-module--aboutSectionMain--2YmAo";
export var moreCards = "AboutSectionWithCard-module--moreCards--nJ4ff";
export var lightIcon = "AboutSectionWithCard-module--lightIcon--n1AuB";
export var aboutSectionHeader = "AboutSectionWithCard-module--aboutSectionHeader--2xzRM";
export var cardSection = "AboutSectionWithCard-module--cardSection--3K270";
export var adSection = "AboutSectionWithCard-module--adSection--1gYb8";
export var ad = "AboutSectionWithCard-module--ad--3YzXa";
export var adIcon = "AboutSectionWithCard-module--adIcon--1Xyjx";
export var adHeader = "AboutSectionWithCard-module--adHeader--87ZU_";
export var adText = "AboutSectionWithCard-module--adText--B9RML";